export default {
    VERIFY_EMAIL: "VERIFY_EMAIL",
    VERIFY_OTP: "VERIFY_OTP",
    CHANGE_PSWD: "CHANGE_PSWD",
}